import React,{useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
//components
import Title from 'components/backoffice/texts/title';
import MenuMattersForm from 'components/backoffice/forms/menuMattersForm';


const CreateMenuMatters = () => {
  const { t } = useTranslation(['backoffice']);
  const {setTitle} = useOutletContext()

  useEffect(()=>{
    setTitle(t('createMenuMatters'))
    return () => {
      setTitle('');
    };
  },[setTitle])

  return (
    <>
      <Title text={t('createMenuMatters')} />
      <MenuMattersForm />
    </>
  );
};

export default CreateMenuMatters;
